module.exports = __webpack_public_path__ + "img/windowHello.82457224.png";